import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import { HeaderDasNew, MainBody, OverlayLoader } from "components/core";
import ClaimsTable from "../components/ClaimsTable";
import { ClaimsMisHeader, SearchBarWrapper } from "../styles";
import SearchBar from "./SearchBar";
import { colors } from "theme";
import { debounce } from "lodash";
import { downloadMis } from "../utils";
import FilterBar from "./FilterBar";
import http from "services/httpService";

function ClaimsMis() {
  const [loading, setLoading] = useState(true);
  const [searchStr, setSearchStr] = useState("");
  const [headers, setHeaders] = useState([])
  const [tableData, setTableData] = useState([])
  const [filterValue, setFilterValue] = useState([])
  const [filterArray, setFilterArray] = useState([])

  const companyName = localStorage.getItem("company_name");

  useEffect(()=>{
   fetchData()
  }, [])

  const fetchData = async (value) => {
    try{
      let payload ={};
      if (value) {
        payload.filter_query_string = value;
      }
      
      if (searchStr) {
        payload.search_query_string = searchStr;
      }
      const {data} = await http.get('business/get_mis_claims/', {params:payload})
      setHeaders(data.headers)
      setTableData(data.claim_mis)
      !value && statusArray(data.claim_mis)
      setLoading(false)
    }catch(e){
      console.log(e)
    }
  }
  
  const statusArray = (value) => {
    const statusReducer = (acc, val) => {
      if (!acc.includes(val.claim_status)) {
        acc.push(val.claim_status);
      }
      return acc;
    };

    const accurateValue = value.reduce(statusReducer, []).sort()
    setFilterValue(accurateValue)
    return accurateValue;
  };

  const debouncedSearchHandler = useCallback(
    debounce(async (value) => {
      
      let payload ={};
      console.log({value})
      if (value) {
        payload.search_query_string = value;
      }
      
      if (searchStr) {
        payload.filter_query_string= filterArray;
      }
      try{
        const {data} = await http.get('business/get_mis_claims/', {
          params: payload
        })
        setTableData(data.claim_mis)
        console.log(data)
      } catch {

      }
    }, 500),
    []
  );

  const searchHandler = (e) => {
    const value = e.target.value;
    setSearchStr(value);
    debouncedSearchHandler(value);
  };

  const filterHandler = useMemo(()=>{
    const new_array = Array.from(filterArray)
    console.log(new_array, new_array.length)
    if(!new_array.length) { fetchData();return}
    const search_string = JSON.stringify(Array.from(filterArray))
    fetchData(search_string)
  }, [filterArray])

  return (
    <>
      {loading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={companyName} />

          <MainBody>
            <ClaimsMisHeader>
              <PageHeader header="Claims MIS" prev_page />
              {/* <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={downloadMis}
                sx={{
                  marginBottom: "24px",
                  backgroundColor: colors.accentColor,
                  fontSize: "14px",
                  textTransform: "capitalize",
                  fontFamily: "Inter",
                }}
              >
                Download Complete Data
              </Button> */}
            </ClaimsMisHeader>
            <SearchBarWrapper>
              <SearchBar value={searchStr} onChange={searchHandler} />
              <FilterBar filters={filterValue} onChange={setFilterArray}/>
            </SearchBarWrapper>
            <ClaimsTable headers={headers} rows={tableData} />
          </MainBody>
        </>
      )}
    </>
  );
}

export default ClaimsMis;
